// Sub-modal del EnviarCorreoModal: elige una evidencia YA en el servidor para
// adjuntarla al correo sin ZIP. Las elegibles (tipo permitido y <=10MB) son
// clickeables; las demás salen en gris con el motivo. Imagen → el padre
// pregunta inline-vs-adjunta; no-imagen liviana → adjunta directo.
//
// La lista en sí es `components/evidencias/SelectorEvidencias` (compartida con
// la bitácora); aquí solo vive la regla de qué se puede adjuntar a un correo.
import type { EvidenciaOut } from "@/lib/api";
import SelectorEvidencias from "@/components/evidencias/SelectorEvidencias";
import { evidenciaAdjuntable } from "@/components/correo/utilsCorreo";

const MOTIVO_TXT: Record<string, string> = {
  pesada: "Muy pesada — usa ZIP",
  tipo: "Tipo no adjuntable — usa ZIP",
  purgada: "Ya no está en el servidor",
};

export default function SelectorEvidenciasModal({
  casoId,
  onClose,
  onElegirImagen,
  onAdjuntar,
}: {
  casoId: number;
  onClose: () => void;
  onElegirImagen: (ev: EvidenciaOut) => void;
  onAdjuntar: (ev: EvidenciaOut) => void;
}) {
  return (
    <SelectorEvidencias
      casoId={casoId}
      onClose={onClose}
      titulo="Adjuntar desde evidencias"
      descripcion="Elige una evidencia liviana del caso para adjuntarla al correo sin ZIP."
      elegible={(ev) => {
        const { ok, motivo } = evidenciaAdjuntable(ev);
        return { ok, motivo: motivo ? MOTIVO_TXT[motivo] : undefined };
      }}
      // El padre cerraba el modal por su cuenta al elegir; se conserva ese trato.
      multiple
      onElegir={(ev) => (ev.mime.startsWith("image/") ? onElegirImagen(ev) : onAdjuntar(ev))}
    />
  );
}
